import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import API from "../../config/axios";
import { api_paths } from "../../config/api.paths";
import SelectField from "../common/SelectField";
import { toastSuccessMessage, toastErrorMessage } from "../../utils/utils";
import { editMobileSchema } from "../../validators/validatorSchema";
import { validateData, clearError } from "../../validators/YupValidations";
import { SET_LOADING } from "../../redux/user";
import { useDispatch } from "react-redux";
import { formatUSPhone, normalizePhoneForSave } from "../../utils/phoneFormat";

// -------------------------------------------
// CONSTANTS
// -------------------------------------------
const COUNTRY_CODE_OPTIONS = [
  { value: "+1", label: "+1" },
  { value: "+91", label: "+91" },
];

const INITIAL_FORM = {
  phone: "",
  country_code: "+1",
};

const EditMobileModal = ({
  show,
  onHide,
  // editData,
  refreshList,
  onOtpOpen,
}) => {
  const [form, setForm] = useState(INITIAL_FORM);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    if (!show) return;

    // Reset form every time modal opens
    setForm({
      phone: "",
      country_code: "+1",
    });

    setErrors({});
  }, [show]);

  const handleChange = (field, value) => {
    if (field === "phone") {
      if (form.country_code === "+1") {
        // keep max 10 digits
        const digits = value.replace(/\D/g, "").slice(0, 10);
        value = formatUSPhone(digits); // format for display
      } else {
        value = value.replace(/\D/g, "").slice(0, 15); // other countries: digits only
      }
    }

    setForm((prev) => ({ ...prev, [field]: value }));

    if (errors[field]) clearError(setErrors, field);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formForValidation = {
      ...form,
      phone:
        form.country_code === "+1"
          ? normalizePhoneForSave(form.phone)
          : form.phone.replace(/\D/g, ""),
    };

    const isValid = await validateData(
      editMobileSchema,
      formForValidation,
      setErrors
    );
    if (!isValid) return;

    try {
      dispatch(SET_LOADING(true));

      const payload = {
        country_code: form.country_code,
        phone: formForValidation.phone,
      };

      const response = await API.post(api_paths.member.EDIT_PHONE, payload);

      const otpId = response?.data?.payload?.result || null;
      toastSuccessMessage("OTP sent successfully");
      onHide();
      onOtpOpen && onOtpOpen(otpId);
    } catch (err) {
      toastErrorMessage("Failed to send OTP");
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="w-100 text-center fw-semibold update-mo-title">
          Update Mobile Number
        </Modal.Title>
      </Modal.Header>

      <form onSubmit={handleSubmit}>
        <Modal.Body className="pt-3 px-4 pb-4">
          <label className="small fw-semibold mb-2">Mobile Number</label>

          <div className="d-flex gap-2">
            {/* Country Code */}
            <div style={{ width: "100px" }}>
              <SelectField
                value={COUNTRY_CODE_OPTIONS.find(
                  (opt) => opt.value === form.country_code
                )}
                options={COUNTRY_CODE_OPTIONS}
                onChange={(opt) => {
                  const newCode = opt.value;
                  setForm((prev) => ({
                    ...prev,
                    country_code: newCode,
                    phone:
                      newCode === "+1"
                        ? formatUSPhone(normalizePhoneForSave(prev.phone))
                        : prev.phone.replace(/\D/g, ""),
                  }));
                }}
              />
            </div>

            {/* Phone */}
            <div className="flex-grow-1">
              <input
                type="tel"
                placeholder="Enter New Mobile Number"
                className={`form-control form-control-sm ${
                  errors.phone ? "is-invalid" : ""
                }`}
                value={form.phone}
                onChange={(e) => handleChange("phone", e.target.value)}
                maxLength={form.country_code === "+1" ? 15 : 10}
              />

              {errors.phone && (
                <div className="invalid-feedback d-block">
                  {errors.phone.message}
                </div>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-0 px-4 pb-4">
          <Button
            type="submit"
            className="w-100 btn-orange-lg"
            style={{
              backgroundColor: "#F4A528",
              border: "none",
              fontWeight: 600,
              fontSize: "16px",
              borderRadius: "8px",
            }}
          >
            Send OTP
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default EditMobileModal;
